import { render, staticRenderFns } from "./EFPPTask.vue?vue&type=template&id=5e639803&"
import script from "./EFPPTask.vue?vue&type=script&lang=js&"
export * from "./EFPPTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EFPPTask.vue"
export default component.exports